import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useIssueReportTopics } from "../../../../hooks/useIssueReportTopics"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { IssueReportTopicGet } from "../../../models/IssueReportTopic"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function IssueReportTopics() {
  const { issueReportTopicsList, isLoadingIssueReportTopics } = useIssueReportTopics()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/issue-reports/topics",
    },
    { field: "applicationName", headerName: "App" },
    { field: "priority", headerName: "Priority" },
  ]

  const sorted = [...issueReportTopicsList].sort(
    (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
  )

  const rows = sorted.map((issueReportTopic: IssueReportTopicGet) => ({
    id: issueReportTopic.id,
    name: issueReportTopic.name,
    applicationName: issueReportTopic.application.name,
    priority: issueReportTopic.priority,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/issue-reports/topics/create"
        feature={DimaFeatureShortNameEnum.IR}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/issueReportTopics/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingIssueReportTopics}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
